import {
  GETLOGINBLOCKLIST_SUCCESS,
  GETLOGINBLOCKLIST_FAILED,
  RESET_GETLOGINBLOCKLIST,
  LOADING_GETLOGINBLOCKLIST,
  NETWORK_ERROR_GETLOGINBLOCKLIST,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
  message: "",
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_GETLOGINBLOCKLIST:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
        message: "",
        networkError: "",
      };
    case GETLOGINBLOCKLIST_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case GETLOGINBLOCKLIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case NETWORK_ERROR_GETLOGINBLOCKLIST:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
        message: "",
        networkError: "",
      };
    case RESET_GETLOGINBLOCKLIST:
      return (state = initialState);
    default:
      return state;
  }
};
